import React, { useState } from 'react';
import {Link,useHistory} from 'react-router-dom';
import api from '../../services/api'
import {FiArrowLeft} from 'react-icons/fi'
import './styles.css';
import logoImg from '../../assets/logo.svg';

export default function Cadastro() {
    const [name,setName] = useState('');
    const [email,setEmail] = useState('');
    const [whatsapp,setWhtas] = useState('');
    const [city,setCity] = useState('');
    const [uf,setUf] = useState('');

    async function handleRegister(e){
        e.preventDefault();

        const data = {name,email,whatsapp,city,uf};
        try{
            const res = await api.post('ongs',data);
            alert(`Seu ID de acesso ${res.data.id}`);
            useHistory.push('/');
            
        }catch{
            alert( 'Error')
        }
        
    }
  return (
    <div className="register-container">
        <div className="content">
            <section>
                <img src={logoImg} alt="Be The Hero"/>
                <h1>Cadastro</h1>
                <p>Faça seu cadastro, em na plataforma e ajude pessoas a encontratrem os casos da sua ONG.</p>
                <Link className="link" to="/">
                    <FiArrowLeft size={16} color="e02041"/>
                     Já tenho cadastro
                </Link>
            </section>
            <form onSubmit={handleRegister}>
                <input placeholder="Nome da ONG" 
                    value={name}
                    onChange={e => setName(e.target.value)}
                />
                <input type="email" placeholder="E-mail"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                />
                <input placeholder="Whatsapp"
                    value={whatsapp}
                    onChange={e => setWhtas(e.target.value)}
                />

                <div className="input-group">
                    <input placeholder="Cidade" 
                        value={city}
                        onChange={e => setCity(e.target.value)}
                    />
                    <input placeholder="UF" style={{width:80}}
                        maxLength="2" 
                        value={uf}
                        onChange={e => setUf(e.target.value)}
                    />
                </div>

                <button className="button" type="submit">Cadastrar</button>
            </form>            
        </div>
    </div>
  );
}
